module.exports = __webpack_public_path__ + "img/15_002.522c0bf2.webp";